module.exports = __webpack_public_path__ + "img/Lime-24-Blog-Banner9.2b03eb8e.jpg";